import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["object"],
    data: (
        customerID: number,
        groupID: number,
        eLynxObject: IeLynxObject,
        date: Date | undefined,
        offline: boolean,
        useLKVOffline: boolean,
        configurationID: number | undefined
    ) => [
            ...keys.all,
            "values", {
                customerID,
                groupID,
                eLynxObject,
                date,
                offline,
                useLKVOffline,
                configurationID
            }
        ]
};
